import React from 'react'

const BathroomRemodelIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      <path d="M28.65,10.28,48.93,38.85l-2.6,1.84L26.05,12.13l2.6-1.85M29.54,5l-8.76,6.22L45.44,46l8.76-6.22L29.54,5Z" />
      <rect
        x="54.79"
        y="44.25"
        width="1.23"
        height="12.94"
        transform="translate(-19.14 41.46) rotate(-35.39)"
      />
      <polygon points="52.61 42.46 48.52 45.35 58.2 58.99 62.29 56.09 52.61 42.46 52.61 42.46" />
      <path d="M20.24,19.38l8.45,11.89L26.9,32.54,18.46,20.65l1.78-1.27m.9-5.27-8,5.65L26,37.81l8-5.65-12.81-18Z" />
      <rect
        x="6.55"
        y="23.12"
        width="6.73"
        height="1.92"
        transform="translate(-12.11 10.18) rotate(-35.37)"
      />
      <polygon points="12.1 21.35 6.61 25.25 7.72 26.82 13.21 22.92 12.1 21.35 12.1 21.35" />
      <rect
        x="1.88"
        y="27.31"
        width="4.29"
        height="1.92"
        transform="translate(-15.62 7.54) rotate(-35.37)"
      />
      <polygon points="5.21 26.24 1.71 28.73 2.83 30.29 6.32 27.81 5.21 26.24 5.21 26.24" />
      <rect
        x="7.33"
        y="29.49"
        width="4.53"
        height="1.92"
        transform="translate(-15.86 11.18) rotate(-35.37)"
      />
      <polygon points="10.88 28.36 7.19 30.98 8.3 32.55 12 29.93 10.88 28.36 10.88 28.36" />
      <rect
        x="12"
        y="26.17"
        width="4.53"
        height="1.92"
        transform="translate(-13.08 13.27) rotate(-35.37)"
      />
      <polygon points="15.56 25.04 11.86 27.66 12.98 29.23 16.67 26.61 15.56 25.04 15.56 25.04" />
      <rect
        x="2.45"
        y="33.04"
        width="4.29"
        height="1.92"
        transform="translate(-18.83 8.94) rotate(-35.37)"
      />
      <polygon points="5.79 31.98 2.29 34.46 3.41 36.03 6.9 33.54 5.79 31.98 5.79 31.98" />
      <rect
        x="9.49"
        y="35.41"
        width="4.53"
        height="1.92"
        transform="translate(-18.89 13.52) rotate(-35.37)"
      />
      <polygon points="13.05 34.28 9.36 36.9 10.47 38.47 14.16 35.84 13.05 34.28 13.05 34.28" />
      <rect
        x="14.17"
        y="32.09"
        width="4.53"
        height="1.92"
        transform="translate(-16.1 15.61) rotate(-35.37)"
      />
      <polygon points="17.72 30.96 14.03 33.58 15.14 35.15 18.83 32.53 17.72 30.96 17.72 30.96" />
      <rect
        x="4.62"
        y="38.96"
        width="4.29"
        height="1.92"
        transform="translate(-21.86 11.28) rotate(-35.37)"
      />
      <polygon points="7.95 37.9 4.46 40.38 5.57 41.95 9.07 39.46 7.95 37.9 7.95 37.9" />
      <rect
        x="13.12"
        y="40.22"
        width="4.53"
        height="1.92"
        transform="translate(-21 16.51) rotate(-35.37)"
      />
      <polygon points="16.68 39.08 12.98 41.71 14.1 43.27 17.79 40.65 16.68 39.08 16.68 39.08" />
      <rect
        x="17.79"
        y="36.9"
        width="4.53"
        height="1.92"
        transform="translate(-18.22 18.6) rotate(-35.37)"
      />
      <polygon points="21.35 35.77 17.65 38.39 18.77 39.96 22.46 37.34 21.35 35.77 21.35 35.77" />
      <rect
        x="8.24"
        y="43.77"
        width="4.29"
        height="1.92"
        transform="translate(-23.97 14.27) rotate(-35.37)"
      />
      <polygon points="11.58 42.7 8.08 45.18 9.2 46.75 12.69 44.27 11.58 42.7 11.58 42.7" />
    </svg>
  )
}

export default BathroomRemodelIcon
